<script setup lang="ts">
import {CheckIcon, TriangleAlertIcon, XIcon } from "lucide-vue-next";
import type {StockResponse} from "../../../responses/StockResponse.ts";
import {label} from "../../mixins/translations.ts";

interface Props {
    stock: StockResponse
}
const props = defineProps<Props>();
</script>

<template>
    <div class="flex min-w-0 items-center gap-2 text-sm font-semibold text-primary antialiased sm:text-base" v-if="stock.stock >= 5">
        <CheckIcon class="h-5 w-5 shrink-0" />
        <span class="leading-5">{{ label('site.stock.in_stock') }}</span>
    </div>
    <div class="flex min-w-0 items-center gap-2 text-sm font-semibold text-orange-500 antialiased sm:text-base" v-else-if="stock.stock > 0">
        <TriangleAlertIcon class="h-5 w-5 shrink-0" />
        <span class="leading-5">{{ label('site.stock.last_stock', {'stock': stock.stock}) }}</span>
    </div>
    <div class="flex min-w-0 items-center gap-2 text-sm font-semibold text-error-700 antialiased sm:text-base" v-else>
        <XIcon class="h-5 w-5 shrink-0" />
        <span class="leading-5">{{ label('site.stock.out_of_stock') }}</span>
    </div>
</template>

